import { NormalizedUnitNumber } from '@/domain/types/NumericValues'
import { Token } from '@/domain/types/Token'
import { Button } from '@/ui/atoms/button/Button'

import { ActionDetails } from './ActionDetails'
interface ActionRowProps {
  token: Token
  value: NormalizedUnitNumber
  label: string
  buttonText: string
  alwaysEnabled?: boolean
  onAction: () => void
  warningText?: string
  infoText?: string
}

export function ActionRow({
  token,
  value,
  label,
  buttonText,
  alwaysEnabled,
  onAction,
  warningText,
  infoText,
}: ActionRowProps) {
  return (
    <div className="grid grid-cols-[_1fr,_70px] border-border border-t py-4">
      <ActionDetails label={label} token={token} value={value} infoText={infoText} warningText={warningText} />
      <Button disabled={!alwaysEnabled && value.isZero()} size="sm" onClick={onAction}>
        {buttonText}
      </Button>
    </div>
  )
}
